<a :href="baseUrl + '/' + urlName" class="projects-card">
	<div class="projects-card__image-and-video-wrap">
		<template v-if="heroImage">
			<img :src="heroImage+'?$nhwHeroThumb$&qlt=90'" :alt="heroImageAltText" class="projects-card__image">
		</template>
	</div>
	<div class="projects-card__ambassador">
		<template v-if="ambassadorImage">
			<img class="projects-card__ambassador-image" :src="ambassadorImage" width="82" height="82" :alt="'Photo of Ambassador' + ambassadorDisplayTitle"/>
		</template>
		<template v-else-if="ambassadorImageNormal">
			<img class="projects-card__ambassador-image" :src="ambassadorImageNormal+'?wid=82&hei=82&qlt=100'" :alt="ambassadorImageNormalAltText" />
		</template>
	</div>	
	<a href="#" @click="$emit('favoriteProjectRemoved', $event, urlName)" class="projects-card__wishlist-toggle js-save-for-later" v-bind:class="isFavorites===true ? 'state-favorited' :''" :data-project="urlName">
		<i class="icon-favorite-outline" v-bind:class="isFavorites ? 'state-checked' : ''"></i>
	</a>
	<div class="projects-card__content">
		<div class="projects-card__title">
			<div class="projects-card__kicker" v-if="projectType && projectType.Text">{{projectType.Text}}</div>
			<div>{{projectTitle}}</div>
			<div class="projects-card__author">By {{ambassadorDisplayTitle}}</div>
		</div>
		<div class="projects-card__footer" v-if="projectType && projectType.PersistedValue === 'howTo'">
			<div class="projects-card__footer-row">
				<div class="projects-card__footer-col-1" v-if="difficulty && difficulty.PersistedValue != 'not_applicable'">
					<div class="projects-card__icon-col">
						<template v-if="difficulty.PersistedValue === 'easy'">
							<img src="https://images.national-hardware.com/is/image/nh/difficulty%2Dbeginner?$nhwFeatureIcon$" alt="difficulty: @(difficulty.PersistedValue) icon"/>
						</template>
						<template v-if="difficulty.PersistedValue === 'moderate'">
							<img src="https://images.national-hardware.com/is/image/nh/difficulty%2Dintermediate?$nhwFeatureIcon$" alt="difficulty: @(difficulty.PersistedValue) icon"/>
						</template>
						<template v-if="difficulty.PersistedValue === 'difficult'">
							<img src="https://images.national-hardware.com/is/image/nh/difficulty%2Dexpert?$nhwFeatureIcon$" alt="difficulty: @(difficulty.PersistedValue) icon"/>
						</template>
					</div>
					<div class="projects-card__difficulty-col">
						<div class="projects-card__kicker">{{translations['WorkbenchFiltering.Difficulty']}}</div>
						<div class="projects-card__difficulty">{{difficulty.Text}}</div>
					</div>
				</div>
				<div class="projects-card__footer-col-2" v-if="time && time.PersistedValue != 'not_applicable'">
					<div class="projects-card__icon-col">
						<template v-if="time.PersistedValue === 'time_1'">
							<img src="https://images.national-hardware.com/is/image/nh/under1hr?$nhwFeatureIcon$" alt="Under 1 hr icon"/>
						</template>
						<template v-if="time.PersistedValue === 'time_2_to_4'">
							<img src="https://images.national-hardware.com/is/image/nh/under24hrs?$nhwFeatureIcon$" alt="Between 2hrs and 4hrs icon"/>
						</template>
						<template v-if="time.PersistedValue === 'time_over_6'">
							<img src="https://images.national-hardware.com/is/image/nh/over6hrs?$nhwFeatureIcon$" alt="Over 6 hours" />
						</template>
					</div>
					<div class="projects-card__time-col">
						<div class="projects-card__kicker">{{translations['WorkbenchFiltering.Time']}}</div>
						<div class="projects-card__difficulty">{{time.Text}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</a>
